import { Component } from '@angular/core';
import { BaseModalDirective } from '../../base-modal';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SigninService } from '@app/gateway/signin/signin.service';

@Component({
  selector: 'nh-verify-identity',
  templateUrl: './verify-identity.component.html',
  styleUrls: ['./verify-identity.component.scss'],
  standalone: false
})
export class VerifyIdentityComponent extends BaseModalDirective {

  constructor(
    protected modalRef: BsModalRef,
    protected builder: FormBuilder,
    public signinService: SigninService,
    private router: Router) {
    super(modalRef, builder);
  }

  verifyIdentity(): void {
    this.hide(true);
    const ridpCurrentStatus = sessionStorage.getItem('ridpIdVerifyStatusCode');
    if (ridpCurrentStatus === 'IV') {
      sessionStorage.setItem('ridpdisplayInvestigatePopuponLoad', 'true');
      const userName = sessionStorage.getItem('userName');
      this.signinService.getAccountData(userName).subscribe(data => {
        if (data) {
          sessionStorage.setItem('userName', data['userId']);
          sessionStorage.setItem('currentUser', JSON.stringify(data));
          sessionStorage.setItem('individualId', data['indvId']);
          sessionStorage.setItem('firstTimeAccessSw', data['firstTimeAccessSw']);
          sessionStorage.setItem('ridpSwitch', data['ridpverfStatusCd']);
          data['ridpverfStatusTimeStamp'] ? sessionStorage.setItem('ridpTimestamp', data['ridpverfStatusTimeStamp']) : null;
          data['ridpHubrefNum'] ? sessionStorage.setItem('ridpHubRefNum', data['ridpHubrefNum']) : null;
          data['ridpDocVerfSw'] ? sessionStorage.setItem('documentStatus', data['ridpDocVerfSw']) : null;
          data['rIDPSubmissionCounter'] ? sessionStorage.setItem('ridpSubmissionCount', data['rIDPSubmissionCounter']) : null;
          this.router.navigate(["/", "verify-identity"]);
        }
      });
    } else if (ridpCurrentStatus === 'ST') {
      if (sessionStorage.getItem('documentStatus') === 'ERR') {
        sessionStorage.setItem('ridpNotVerified', 'true')
        sessionStorage.setItem('ridpReviewDocs', 'true')
      } else if(sessionStorage.getItem('documentStatus') === 'IP') {
        sessionStorage.setItem('ridpReviewDocs', 'true')
      }
      this.router.navigateByUrl("/verify-identity/uploadDocuments");
    } else if (ridpCurrentStatus === 'ER' || ridpCurrentStatus === 'ND') {
      if(sessionStorage.getItem('ridpSubmissionCount') >= '3'){
        this.router.navigateByUrl("/verify-identity/uploadDocuments");
      } else {
      sessionStorage.setItem('ridpCantVerifyBanner', 'true')
      this.router.navigate(["/", "verify-identity"]);
      }
    } else {
      this.router.navigate(["/", "verify-identity"]);
    }
  }

  onGoToDashboard(): void {
    this.hide(true);
    this.router.navigate(['/user-profile', 'benefit-dashboard']);
  }
}
